import type { DoseLocation } from "@/types/medication";

type WithLocations = {
  administrationLocation?: string | null;
  locations?: DoseLocation[] | null;
};

/** Whether the dose's locations came from a face chart. They can be edited on
 *  the dose, but the chart writes its own again the next time it is saved. */
export function hasChartLocations(dose: WithLocations): boolean {
  return (dose.locations ?? []).some((location) => location.source === "chart");
}

/** A dose's location as one line. Where amounts were recorded per location it
 *  reads "Glabella 20 · Frontalis 12"; otherwise it is the plain location
 *  text, exactly as before. */
export function formatDoseLocations(dose: WithLocations): string {
  const locations = dose.locations ?? [];
  if (!locations.some((location) => location.amount != null)) {
    return dose.administrationLocation || "";
  }
  return locations
    .map((location) =>
      location.amount != null
        ? `${location.label} ${location.amount}`
        : location.label,
    )
    .join(" · ");
}
